import { CREATE } from "../../dataFetchActions";
import { CRUD_CREATE, CRUD_CREATE_FAILURE, CRUD_CREATE_LOADING, CRUD_CREATE_SUCCESS } from "./crudconstants";

export { CRUD_CREATE, CRUD_CREATE_LOADING, CRUD_CREATE_FAILURE, CRUD_CREATE_SUCCESS };

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const crudCreate = (resource, data, params = {}) => {
  const { context, redirectTo, refresh = true, altFailure, subResource, customAction, id, subId } = params;
  return {
    type: CRUD_CREATE,
    payload: { data },
    meta: {
      resource,
      context,
      subResource,
      id,
      subId,
      customAction,
      fetch: CREATE,
      onSuccess: {
        notification: {
          body: "notification.created",
          level: "info",
          messageArgs: {
            smart_count: 1,
          },
        },
        redirectTo,
        refresh,
      },
      onFailure: altFailure || {
        notification: {
          body: "notification.http_error",
          level: "warning",
        },
      },
    },
  };
};
